export const validatePassword = (_, value) => {
  if (!value) {
    return Promise.reject(new Error("Please input your password!"));
  }
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumbers = /\d/.test(value);
  const hasNonalphas = /\W/.test(value);
  if (value.length < minLength) {
    return Promise.reject(new Error("Password must be at least 8 characters long!"));
  }
  if (!hasUpperCase) {
    return Promise.reject(new Error("Password must contain at least one uppercase letter!"));
  }
  if (!hasLowerCase) {
    return Promise.reject(new Error("Password must contain at least one lowercase letter!"));
  }
  if (!hasNumbers) {
    return Promise.reject(new Error("Password must contain at least one number!"));
  }
  if (!hasNonalphas) {
    return Promise.reject(new Error("Password must contain at least one special character!"));
  }
  return Promise.resolve();
};
